import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, ShieldCheck, UserRound } from "lucide-react";
import { APP_ICON_URL } from "@/lib/assets";
import { fileUrl } from "@/lib/api";

const activeTier = (subscription) => (
  subscription?.state === "active" && ["bank", "bank_amwali_plus"].includes(subscription?.type)
    ? subscription.type
    : "standard"
);

export function EntryVaultShell({ children, className = "" }) {
  return (
    <main className={`entry-vault-shell ${className}`} dir="rtl">
      <div className="entry-vault-backdrop" aria-hidden="true" />
      <div className="entry-vault-veil" aria-hidden="true" />
      <div className="entry-vault-content">{children}</div>
    </main>
  );
}

export function EntryBrand({ compact = false, className = "" }) {
  return (
    <div className={`entry-brand ${compact ? "entry-brand--compact" : ""} ${className}`}>
      <img src={APP_ICON_URL} alt="أيقونة بنك العائلة الرسمية" className="entry-brand__logo" />
      <div className="entry-brand__copy">
        <span className="entry-brand__name">بنك العائلة</span>
        {!compact && <span className="entry-brand__english">Family Bank</span>}
      </div>
    </div>
  );
}

export function EntryBackLink({ to = "/", children = "العودة للرئيسية", testId }) {
  return (
    <Link to={to} className="entry-back-link" data-testid={testId}>
      <ArrowLeft aria-hidden="true" />
      <span>{children}</span>
    </Link>
  );
}

export function EntryAvatar({ user, size = "md", className = "" }) {
  const tier = activeTier(user?.subscription);
  const avatar = user?.avatar_path ? fileUrl(user.avatar_path) : null;
  return (
    <div className={`entry-avatar entry-avatar--${tier} entry-avatar--${size} ${className}`} aria-hidden="true">
      {avatar ? (
        <img src={avatar} alt="" className="entry-avatar__image" />
      ) : (
        <UserRound className="entry-avatar__fallback" />
      )}
    </div>
  );
}

export function EntrySubscription({ subscription, showDays = true }) {
  const tier = activeTier(subscription);
  const Icon = ShieldCheck;
  const label = tier === 'bank' ? 'اشتراك بنك العائلة' : tier === 'bank_amwali_plus' ? 'باقة أموالي +' : 'بدون اشتراك';
  const days = subscription?.days_left;
  const hasDays = showDays && tier !== 'standard' && days !== null && days !== undefined;
  return (
    <div className="entry-subscription">
      <span className={`entry-subscription__badge entry-subscription__badge--${tier}`} data-testid="entry-subscription-badge">
        <Icon aria-hidden="true" />
        <span>{label}</span>
      </span>
      {hasDays && (
        <span className="entry-subscription__days">متبقي <bdi>{days}</bdi> يوماً</span>
      )}
    </div>
  );
}

export function EntryDivider() {
  return <div className="entry-divider" aria-hidden="true"><span /></div>;
}
